import { render, staticRenderFns } from "./dataSidebar.vue?vue&type=template&id=bf433244&scoped=true&"
import script from "./dataSidebar.vue?vue&type=script&lang=js&"
export * from "./dataSidebar.vue?vue&type=script&lang=js&"
import style0 from "./dataSidebar.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./dataSidebar.vue?vue&type=style&index=1&id=bf433244&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf433244",
  null
  
)

export default component.exports